var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA1Socket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 31v14h14.39a2 2 0 011.9 2.65 2 2 0 01-2 1.35H52v7h-7.31A17.75 17.75 0 0127 40.39V40H8v-4h19a18 18 0 0117.69-16H52v7h14.39a2 2 0 011.9 2.65 2 2 0 01-2 1.35H52z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A1_Socket.8bdcfc15.svg";
export { SvgA1Socket as ReactComponent };